import { render } from "./DeveloperItemRadio.vue?vue&type=template&id=ef8d1438"
import script from "./DeveloperItemRadio.vue?vue&type=script&lang=js"
export * from "./DeveloperItemRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__